export default __webpack_public_path__ + "static/media/IMG_5560.ae6e4630.jpg";